import React from 'react';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import { ConditionalWrapper } from '../../primitives/ConditionalWrapper/ConditionalWrapper.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
import { Flex } from '../Flex/Flex.es.js';
import { List } from '../List/List.es.js';
import Popover from '../Popover/Popover.es.js';
import '../Popover/PopoverContext.es.js';
import { Avatar as Avatar$1 } from '../Avatar/Avatar.es.js';
import { Tooltip } from '../Tooltip/Tooltip.es.js';
import Button from '../Button/Button.es.js';
import { Scrollable } from '../Scrollable/Scrollable.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
import '../../utils/assertions.es.js';
import { runIfFn } from '../../utils/functions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { filterChildrenByType } from '../../utils/filterChildrenByType/filterChildrenByType.es.js';
import { AvatarWrapper, Avatar } from './styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const AvatarComponent = forwardRef((props, ref) => {
  const _a = props, {
    src,
    fallback,
    size,
    alt,
    name,
    wrapper: WrapperComponent = React.Fragment,
    wrapperProps,
    hasTooltip = true
  } = _a, rest = __objRest(_a, [
    "src",
    "fallback",
    "size",
    "alt",
    "name",
    "wrapper",
    "wrapperProps",
    "hasTooltip"
  ]);
  return /* @__PURE__ */ React.createElement(AvatarWrapper, __spreadValues({
    ref,
    size
  }, rest), /* @__PURE__ */ React.createElement(WrapperComponent, __spreadValues({}, wrapperProps), /* @__PURE__ */ React.createElement(ConditionalWrapper, {
    condition: hasTooltip,
    wrapper: (children) => /* @__PURE__ */ React.createElement(Tooltip, {
      position: "top",
      content: name ? name : fallback ? fallback : ""
    }, children)
  }, /* @__PURE__ */ React.createElement(Avatar, {
    src,
    fallback,
    size,
    alt
  }))));
});
AvatarComponent.displayName = "AvatarGroup.Avatar";
const popoverPropsDefault = {
  placement: "bottom-end",
  minWidth: "240px",
  maxWidth: "360px",
  maxHeight: "360px",
  overflow: "hidden",
  display: "flex"
};
const AvatarGroupComponent = forwardRef((props, ref) => {
  const _a = props, {
    children,
    size = "md",
    limit = 4,
    total,
    hasPopover = false,
    onTriggerClick,
    popoverProps: popoverPropsProp = {},
    popoverContent
  } = _a, rest = __objRest(_a, [
    "children",
    "size",
    "limit",
    "total",
    "hasPopover",
    "onTriggerClick",
    "popoverProps",
    "popoverContent"
  ]);
  const avatars = filterChildrenByType(children, AvatarComponent);
  const visibleAvatars = avatars.slice(0, limit).map((child, index) => React.cloneElement(child, { size, key: `avatar-${index}`, zIndex: limit - index }));
  const extraAvatars = avatars.slice(limit).map((child, index) => {
    const _a2 = child.props, { name } = _a2, rest2 = __objRest(_a2, ["name"]);
    return /* @__PURE__ */ React.createElement(List.Item, {
      key: `list-item-${index}`
    }, /* @__PURE__ */ React.createElement(List.ItemIcon, null, /* @__PURE__ */ React.createElement(Avatar$1, __spreadValues({}, rest2))), name);
  });
  const nbOfExtraAvatars = avatars.length > limit ? avatars.length - limit : 0;
  const truncatedAvatars = total ? Math.max(nbOfExtraAvatars, total - Math.min(avatars.length, limit)) : nbOfExtraAvatars;
  const popoverProps = __spreadValues(__spreadValues({}, popoverPropsDefault), popoverPropsProp);
  return /* @__PURE__ */ React.createElement(Flex, __spreadValues({
    ref
  }, rest), visibleAvatars, !!truncatedAvatars && /* @__PURE__ */ React.createElement(Box, {
    ml: "xxs"
  }, hasPopover ? /* @__PURE__ */ React.createElement(Popover, __spreadValues({}, popoverProps), ({ close }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Popover.Trigger, null, /* @__PURE__ */ React.createElement(Button, {
    variant: "ghost",
    size,
    isRounded: true
  }, `+${truncatedAvatars}`)), /* @__PURE__ */ React.createElement(Popover.Content, {
    p: 0
  }, popoverContent ? runIfFn(popoverContent, { close }) : /* @__PURE__ */ React.createElement(Scrollable, null, /* @__PURE__ */ React.createElement(List, {
    py: "xs"
  }, extraAvatars))))) : /* @__PURE__ */ React.createElement(Button, {
    as: "span",
    variant: "ghost",
    size,
    isRounded: true,
    onClick: onTriggerClick
  }, `+${truncatedAvatars}`)));
});
AvatarGroupComponent.displayName = "AvatarGroup";
const AvatarGroup = Object.assign(AvatarGroupComponent, { Avatar: AvatarComponent });

export { AvatarGroup };
//# sourceMappingURL=AvatarGroup.es.js.map
